import moment from "moment";

export function calculateDaysUntilToday(expiryDate) {
    const currentDate = moment();
    const expirationDate = moment(expiryDate);
    const daysDifference = expirationDate.diff(currentDate, 'days');
  
    return daysDifference;
  }